import React from "react";
import classNames from "classnames";
import { inject, observer } from "mobx-react";
import { Link } from "react-router-dom";
import Modal from 'react-modal';

const customStyles = {
  content : {
      margin: '0',
      position: 'fixed',
      top: '50%',
      left: '50%',
      width: '100%',
      maxWidth: '500px',
      height: 'fit-content',
      background: 'transparent',
      overflow: 'auto',
      WebkitOverflowScrolling: 'touch',
      border: 'none',
      outline: 'none',
      padding: '0',
      transform: 'translate(-50%,-50%)'
  }
};

@inject("modal")
@inject("alert")
@inject("workshopDetails", "user")
@observer
export default class QuizInfo extends React.Component {
  state = {
    status: "",
    rightAnswers: "",
    modalOpened: false,
  };

  componentWillMount() {
    this.setState({
      ...this.state,
      status: this.props.workshopDetails.workshop.modules[this.props.moduleIdx]
        .status
    });
  }

  closeModal = () => {
    this.setState({
      ...this.state,
      modalOpened: false
    });
  }

  startQuiz = () => {
    this.props.modal.modalContentSetter("quiz_questions");
    this.props.modal.parentIdSetter(this.props.moduleIdx);
    this.props.modal.setSubmitFunction(this.setResults);
    this.props.modal.toggleModal();
  };

  setResults = (response, idx) => {
    this.props.modal.toggleModal();

    if (response.message === "test failed") {
      this.setState({
        ...this.state,
        status: "module_failed",
        rightAnswers: response.quiz_result
      });
    }
    if (response.message === "test completed") {
      this.setState({
        ...this.state,
        status: "module_completed",
        rightAnswers: response.quiz_result,
      });
      this.props.workshopDetails.setCompletedModuleByIdx(idx);
      if (response.completed) {
        this.setState({
          ...this.state,
          modalOpened: true
        });
      };
    }
  };

  render() {
    const questions = this.props.workshopDetails.workshop.modules[this.props.moduleIdx].questions || [];
    const isFiveQuestionz = questions.length === 5;
    let bigText, regularText, btnText, quizButton;
    if (this.state.status === "module_not_started") {
      bigText = "To complete this module, you need to take the quiz";
      regularText = `You must answer ${!isFiveQuestionz ? questions.length : questions.length - 1} out of the ${questions.length} questions correctly`;
      btnText = "take quiz";
    }
    if (this.state.status === "module_failed") {
      bigText = `You answered ${
        this.state.rightAnswers
      } out of ${questions.length} questions correctly`;
      regularText =
        `To complete the module, you need to answer at least ${!isFiveQuestionz ? questions.length : questions.length - 1} questions correctly`;
      btnText = "try again";
    }
    if (this.state.status === "module_completed") {
      bigText = this.state.rightAnswers ? `You have answered ${this.state.rightAnswers} questions correctly and have successfully completed this module` : "Congratulations, you have successfully completed this module" ;
      regularText = "";
      btnText = "completed";
    }
    if (this.state.status === null) {
      bigText = "";
      regularText = "";
      btnText = "click to view";
      quizButton = (
        <Link to={`/createworkshop/${this.props.workshopDetails.workshop.id}`}>
          <button className="btn prime bordered">{btnText}</button>
        </Link>
      );
    } else {
      quizButton = (
        <button className="btn prime bordered" onClick={this.startQuiz}>
          {btnText}
        </button>
      );
    }

    const quizinfoSelector = this.props.moduleIdx + 1;

    return (
      <div
        className={classNames("quizinfo-container", {
          owner: this.state.status === null
        }, { [`${quizinfoSelector}`]: quizinfoSelector})}
      >
        <div
          className={classNames(
            "quizinfo-wrapper",
            {
              start: this.state.status === "module_not_started"
            },
            {
              tryagain: this.state.status === "module_failed"
            },
            {
              passed: this.state.status === "module_completed"
            }
          )}
        >
          <div className="quizinfo-bg-img" />
          <p className="quiz-bigtext">{bigText}</p>
          <p className="quiz-regtext">{regularText}</p>

          {quizButton}
        </div>
        <Modal
          isOpen={this.state.modalOpened}
          style={customStyles}
          shouldCloseOnOverlayClick={true}
          onRequestClose={this.closeModal}
        >
          <div className="quiz-modal">
            <div className="qm-message">
              <p>Congratulations, you have now completed the Workshop.</p>
              <p><Link to={ this.props.user.user.role === 'iacp' ? '/iacp/completed' : '/completed_workshops'} className='alert-underlined-link'>Click here</Link><span> to view your CPD cert for this Workshop.</span></p>
            </div>
            <div className="qm-close">
              <button onClick={this.closeModal}><i className="ic-close-ico"/></button>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/providers/online_workshop_details/quiz/QuizInfo.jsx